import { FC, useMemo } from 'react';
import textile from 'textile-js';
import sanitizeHtml from 'sanitize-html';

interface Props {
    value?: string | null;
    className?: string;
}

const htmlCache = new Map<string, string>();

const normalizeTextile = (text: string): string => {
    return text
        .replace(/\r\n/g, '\n')

        // Bullet list
        .replace(/^[ \t]*[•●▪◦][ \t]+/gm, '* ')
        .replace(/^[ \t]*-[ \t]+/gm, '* ')

        // URL -> Textile-ссылка
        .replace(
            /(?<!")https?:\/\/[^\s<]+/g,
            (url) => `"${url}":${url}`
        )

        .replace(/[ \t]+$/gm, '')
        .replace(/\n{3,}/g, '\n\n');
};

export const formatDescription = (text?: string | null): string => {
    if (!text) {
        return '';
    }

    const cached = htmlCache.get(text);
    if (cached) {
        return cached;
    }

    const normalized = normalizeTextile(text);

    const html = sanitizeHtml(textile(normalized), {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat([
            'img',
            'table',
            'thead',
            'tbody',
            'tfoot',
            'tr',
            'th',
            'td',
            'pre',
            'code',
            'span',
        ]),
        allowedAttributes: {
            ...sanitizeHtml.defaults.allowedAttributes,
            a: ['href', 'target', 'rel'],
            img: ['src', 'alt', 'title'],
            '*': ['style'],
        },
        transformTags: {
            a: (tagName, attribs) => ({
                tagName,
                attribs: {
                    ...attribs,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                },
            }),
        },
    });

    htmlCache.set(text, html);

    return html;
};

const NewsDescription: FC<Props> = ({ value, className }) => {
    const html = useMemo(() => formatDescription(value), [value]);

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};

export default NewsDescription;